
import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: { value: string; label: string }[];
}

const Select: React.FC<SelectProps> = ({ label, error, options, className = '', ...props }) => {
  return (
    <div className="w-full space-y-1.5">
      {label && <label className="text-xs font-bold text-brand-muted uppercase tracking-wider ml-1">{label}</label>}
      <div className="relative">
        <select
          className={`
            w-full bg-brand-dark/50 border border-brand-border rounded-xl px-4 py-3 text-white appearance-none
            focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary/20
            transition-all duration-200 cursor-pointer
            ${error ? 'border-red-500/50 focus:border-red-500' : ''}
            ${className}
          `}
          {...props}
        >
          {options.map(opt => (
            <option key={opt.value} value={opt.value} className="bg-brand-card">
              {opt.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-brand-muted">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
      {error && <p className="text-[10px] text-red-400 font-medium ml-1">{error}</p>}
    </div>
  );
};

export default Select;
